// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billboard-enquiry-container {
  border-radius: 0.625rem;
  background: #fff;
}
.disable-flex.ant-row {
  display: block !important;
}

.quote-in-minute {
  color: var(--Colors-Primary-500, #d2042d);
  text-align: center;
  font-size: var(--Font-Font-Size-h5, 1.4375rem);
  font-style: normal;
  font-weight: 700;
  line-height: 2.1rem;
}
.ready-to-make-text {
  color: #000;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}
.enquiry-modal .ant-modal-close {
  color: #d2042d;
}

.enquiry-modal .ant-modal-close:hover {
  color: #a10024;
}
.request-my-quote {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
}
.we-respect-privacy-row {
  display: flex;
  margin-top: 10px;
  flex-direction: row;
  align-content: stretch;
  justify-content: space-around;
  align-items: center;
}
.respect-privacy-text {
  color: #7d7d7d;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.need-help-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.respect-privacy-number {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  margin-left: 6px;
}
.billbaord-enquiry-quote-row {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}
.request-my-demo-btn-billboard-enquiry {
  background-color: #d2042d;
  height: 2.5rem;
}
.request-my-demo-btn-billboard-enquiry-spin {
  display: flex;
  justify-content: center;
  align-items: center;
}

.enquiry-form-item-css {
  width: 100%;
  margin-top: 10px;
  margin-left: 0px !important;
}

.billboard-select-feild .ant-select-item-option:hover {
  background-color: #d2042d !important;
  color: #fff !important;
}

.billboard-select-dropdown
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  color: #fff;
  background-color: #d2042d;
}
.billboard-select-dropdown.ant-select-dropdown
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  color: #000 !important;
}

.billboard-select-dropdown .ant-select-item-option-active .ant-checkbox-label {
  color: #fff !important;
}

.billboard-select-dropdown
  .ant-select-item-option-selected
  .ant-checkbox-label {
  color: #000 !important;
}

.billboard-text-area.ant-input-textarea-show-count .ant-input-data-count {
  position: absolute;
  bottom: -28px !important;
  inset-inline-end: 0;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  pointer-events: none;
}
@media (min-width: 0px) and (max-width: 320px) {
  .quote-in-minute {
    margin-top: 30px !important;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.1rem;
  }
  .ready-to-make-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 1rem;
    margin-top: 10px;
  }
  .respect-privacy-text {
    font-size: 14px;
    font-weight: 400;
  }
  .respect-privacy-number {
    font-size: 14px;
    font-weight: 400;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/billboard-enquiry-chat/BillboardEnquiryModal.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".billboard-enquiry-container {\n  border-radius: 0.625rem;\n  background: #fff;\n}\n.disable-flex.ant-row {\n  display: block !important;\n}\n\n.quote-in-minute {\n  color: var(--Colors-Primary-500, #d2042d);\n  text-align: center;\n  font-size: var(--Font-Font-Size-h5, 1.4375rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 2.1rem;\n}\n.ready-to-make-text {\n  color: #000;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n.enquiry-modal .ant-modal-close {\n  color: #d2042d;\n}\n\n.enquiry-modal .ant-modal-close:hover {\n  color: #a10024;\n}\n.request-my-quote {\n  margin-top: 1.5rem;\n  display: flex;\n  justify-content: center;\n}\n.we-respect-privacy-row {\n  display: flex;\n  margin-top: 10px;\n  flex-direction: row;\n  align-content: stretch;\n  justify-content: space-around;\n  align-items: center;\n}\n.respect-privacy-text {\n  color: #7d7d7d;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.need-help-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.respect-privacy-number {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  margin-left: 6px;\n}\n.billbaord-enquiry-quote-row {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2rem;\n}\n.request-my-demo-btn-billboard-enquiry {\n  background-color: #d2042d;\n  height: 2.5rem;\n}\n.request-my-demo-btn-billboard-enquiry-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.enquiry-form-item-css {\n  width: 100%;\n  margin-top: 10px;\n  margin-left: 0px !important;\n}\n\n.billboard-select-feild .ant-select-item-option:hover {\n  background-color: #d2042d !important;\n  color: #fff !important;\n}\n\n.billboard-select-dropdown\n  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n  color: #fff;\n  background-color: #d2042d;\n}\n.billboard-select-dropdown.ant-select-dropdown\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n  color: #000 !important;\n}\n\n.billboard-select-dropdown .ant-select-item-option-active .ant-checkbox-label {\n  color: #fff !important;\n}\n\n.billboard-select-dropdown\n  .ant-select-item-option-selected\n  .ant-checkbox-label {\n  color: #000 !important;\n}\n\n.billboard-text-area.ant-input-textarea-show-count .ant-input-data-count {\n  position: absolute;\n  bottom: -28px !important;\n  inset-inline-end: 0;\n  color: rgba(0, 0, 0, 0.45);\n  white-space: nowrap;\n  pointer-events: none;\n}\n@media (min-width: 0px) and (max-width: 320px) {\n  .quote-in-minute {\n    margin-top: 30px !important;\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 1.1rem;\n  }\n  .ready-to-make-text {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1rem;\n    margin-top: 10px;\n  }\n  .respect-privacy-text {\n    font-size: 14px;\n    font-weight: 400;\n  }\n  .respect-privacy-number {\n    font-size: 14px;\n    font-weight: 400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
